<script>
import axios from 'axios';

export default {
    name: 'SlowSpansPanel',
    props: {
        spansUrl: { type: String, required: true },
    },
    emits: ['open-trace'],
    data() {
        return {
            loading: false,
            sinceHours: 24,
            prefix: '',
            spans: [],
            error: null,
        };
    },
    created() {
        this.refresh();
    },
    methods: {
        async refresh() {
            this.loading = true;
            this.error = null;
            try {
                const { data } = await axios.get(this.spansUrl, {
                    params: {
                        since_hours: this.sinceHours,
                        prefix: this.prefix || undefined,
                    },
                });
                this.spans = data.spans;
            } catch (e) {
                this.error = e.response?.data?.message || 'Failed to load slow spans.';
            } finally {
                this.loading = false;
            }
        },
        formatTs(ts) {
            return ts ? ts.replace('T', ' ').replace(/\+.*$/, '') : '';
        },
    },
};
</script>

<template>
    <div class="slow-spans-panel">
        <form class="form-inline" style="margin-bottom: 12px" @submit.prevent="refresh">
            <label class="control-label" style="margin-right: 8px">Window (h)</label>
            <input v-model.number="sinceHours" type="number" min="1" max="8760" class="form-control input-sm" style="width: 80px" />
            <label class="control-label" style="margin: 0 8px">Prefix</label>
            <select v-model="prefix" class="form-control input-sm">
                <option value="">all</option>
                <option value="http">http</option>
                <option value="job">job</option>
                <option value="pipe">pipe</option>
                <option value="beestore.soap">beestore.soap</option>
            </select>
            <button type="submit" class="btn btn-sm btn-primary" style="margin-left: 8px" :disabled="loading">
                <i class="fa fa-refresh" :class="{ 'fa-spin': loading }"></i> Load
            </button>
        </form>

        <div v-if="error" class="alert alert-danger">{{ error }}</div>

        <table class="table table-condensed table-hover">
            <thead>
                <tr>
                    <th>Span</th>
                    <th>Samples</th>
                    <th>Avg ms</th>
                    <th>Max ms</th>
                    <th>Last seen</th>
                    <th>Sample correlation</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="span in spans" :key="span.span_name">
                    <td><code>{{ span.span_name }}</code></td>
                    <td>{{ span.samples }}</td>
                    <td>{{ span.avg_ms }}</td>
                    <td><strong>{{ span.max_ms }}</strong></td>
                    <td class="text-muted">{{ formatTs(span.last_seen_at) }}</td>
                    <td>
                        <a
                            v-if="span.sample_correlation_id"
                            href="#"
                            @click.prevent="$emit('open-trace', span.sample_correlation_id)"
                        >
                            <code>{{ span.sample_correlation_id }}</code>
                        </a>
                    </td>
                </tr>
                <tr v-if="!spans.length && !loading">
                    <td colspan="6" class="text-center text-muted" style="padding: 30px">
                        No slow spans in this window.
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
